import {Form} from 'react-router-dom';
import modalStyles from '../../../components/modal/modal.module.scss';
import {useIsNavigatingOrPending} from '../../../support/use_is_navigating_or_pending';
import {__} from '../../../support/lang/translations';
import React, {useCallback} from 'react';
import {useClickOutside} from '../../../support/use_click_outside.ts';
import {FlexRow} from '../../../components/utility/flex_row.tsx';
import {Alignment} from '../../../enums/alignment.ts';
import {FlexColumn} from '../../../components/utility/flex_column.tsx';
import {Icon} from '../../../components/icon/icon.tsx';
import {Card} from '../../../components/card/card.tsx';
import {AltButton} from '../../../components/button/alt_button.tsx';
import {ButtonColorType} from '../../../enums/button_color_type.ts';

interface OwnProps {
    onCloseModal: () => void;
}

export function PrivacyModal(props: OwnProps) {
    const isLoading = useIsNavigatingOrPending((state) => state.customerInfo.status);
    const ref = React.useRef<HTMLDivElement | null>(null);

    const closeModalCallback = useCallback(() => {
        props.onCloseModal();
    }, []);
    useClickOutside(ref, closeModalCallback);

    return (
        <div className={modalStyles.modal_backdrop}>
            <div className={modalStyles.modal}>
                <div className={modalStyles.modal_dialog} ref={ref}>
                    <div className={modalStyles.modal_header}>
                        <span />
                        <h2>{__('onboarding.privacy_agreement.modal.title')}</h2>
                        <button disabled={isLoading} type="button" onClick={() => props.onCloseModal()}>
                            <i className="fa-light fa-close"></i>
                        </button>
                    </div>
                    <div className={modalStyles.modal_body}>
                        <p style={{margin: '0 0 2rem 0'}}>{__('onboarding.privacy_agreement.modal.explanation')}</p>
                        <Form method="delete">
                            <Card gray={true} style={{margin: '0 0 1rem 0'}}>
                                <FlexRow>
                                    <FlexColumn>
                                        <FlexRow>
                                            <Icon iconClassName="fa-light fa-trash-can" outline={true} />
                                            <strong style={{margin: '0 auto 0 1rem'}}>
                                                {__('onboarding.privacy_agreement.modal.delete')}
                                            </strong>
                                        </FlexRow>
                                    </FlexColumn>
                                    <FlexColumn>
                                        <FlexRow>
                                            <FlexColumn alignment={Alignment.End}>
                                                <AltButton disabled={isLoading} type="submit">
                                                    <i className="fa-light fa-trash-can"></i>
                                                </AltButton>
                                            </FlexColumn>
                                        </FlexRow>
                                    </FlexColumn>
                                </FlexRow>
                            </Card>
                        </Form>

                        <Card to="/logout" gray={true} arrow={true} style={{margin: '0 0 1rem 0'}}>
                            <FlexRow alignment={Alignment.Start}>
                                <FlexColumn>
                                    <Icon iconClassName="fa-light fa-arrow-right-from-bracket" outline={true} />
                                </FlexColumn>
                                <FlexColumn>
                                    <strong style={{margin: '0 auto 0 1rem'}}>
                                        {__('onboarding.privacy_agreement.modal.logout')}
                                    </strong>
                                </FlexColumn>
                            </FlexRow>
                        </Card>
                        <Card gray={true} style={{margin: '0 0 1rem 0'}}>
                            <FlexRow>
                                <FlexColumn>
                                    <FlexRow>
                                        <Icon iconClassName="fa-light fa-check text-green" outline={true} />
                                        <strong style={{margin: '0 auto 0 1rem'}}>
                                            {__('onboarding.privacy_agreement.modal.agree')}
                                        </strong>
                                    </FlexRow>
                                </FlexColumn>
                                <FlexColumn alignment={Alignment.End}>
                                    <AltButton
                                        disabled={isLoading}
                                        type="submit"
                                        form="onboarding_form"
                                        colorType={ButtonColorType.Green}
                                    >
                                        <i className="fa-light fa-check"></i>
                                    </AltButton>
                                </FlexColumn>
                            </FlexRow>
                        </Card>
                    </div>
                </div>
            </div>
        </div>
    );
}
